import { Tab as MuiTab, TabProps, Typography } from '@mui/material';

import { ReactComponent as CheckIcon } from '../assets/check.svg';

interface Props
  extends Omit<TabProps, 'iconPosition' | 'disableFocusRipple' | 'icon'> {
  passed: boolean;
}

export function Tab({ label, passed, ...props }: Props): JSX.Element {
  return (
    <MuiTab
      {...props}
      iconPosition="start"
      disableFocusRipple
      icon={passed ? <CheckIcon /> : undefined}
      label={
        <Typography variant="button2" component="span">
          {label}
        </Typography>
      }
    />
  );
}
